import { render, staticRenderFns } from "./DfAutocompleteField.vue?vue&type=template&id=5ecaa1ad&scoped=true&"
import script from "./DfAutocompleteField.vue?vue&type=script&lang=js&"
export * from "./DfAutocompleteField.vue?vue&type=script&lang=js&"
import style0 from "./DfAutocompleteField.vue?vue&type=style&index=0&id=5ecaa1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecaa1ad",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecaa1ad')) {
      api.createRecord('5ecaa1ad', component.options)
    } else {
      api.reload('5ecaa1ad', component.options)
    }
    module.hot.accept("./DfAutocompleteField.vue?vue&type=template&id=5ecaa1ad&scoped=true&", function () {
      api.rerender('5ecaa1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfAutocompleteField.vue"
export default component.exports